module.exports = __webpack_public_path__ + "img/图片4.a2e559df.png";